import type { Project } from '../types'

export const projects: Project[] = [
  {
    id: 1,
    skills: ['React', 'TypeScript', 'Node.js', 'PostgreSQL', 'Analytics'],
    title: 'Nike Digital Commerce Platform',
    description:
      'Architected enterprise-scale e-commerce platform processing millions of daily transactions. Implemented microservices architecture with real-time inventory management, reducing checkout time by 40%.',
    preview: 'https://nike.com',
    code: 'https://github.com/Nike-Inc',
    category: ['web'], // Changed to array
    image: 'nike-logo',
    stats: { users: '10M+', performance: '40%↑', speed: '2d→15m' },
  },
  {
    id: 2,
    skills: ['Machine Learning', 'TensorFlow', 'React 19', 'TypeScript'],
    title: 'Car Emissions ML Classifier',
    description:
      'Intelligent web application that predicts vehicle emissions test results using multinomial logistic regression. Analyzes 7 key automotive features including MPG, horsepower, cylinders, and more. Features real-time training visualization, adaptive learning rates, and supports CSV uploads.',
    preview: 'https://car-emissions-ml.web.app/',
    code: 'https://github.com/liamkande/ml-car-emissions.git',
    category: ['ai', 'ml', 'web'],
    image: 'car-emissions-logo',
    stats: {
      model: 'Softmax',
      accuracy: '+95%',
      variables: '7',
    },
  },
  {
    id: 3,
    skills: ['Machine Learning', 'TensorFlow', 'React 19', 'TypeScript', 'Vite'],
    title: 'House Price ML Predictor',
    description:
      'Machine learning web application that predicts residential property prices using geographic location, lot size, and living area features. Uses K-Nearest Neighbors algorithm to analyze housing market data and predict accurate valuations with real-time computation powered by TensorFlow.',
    preview: 'https://knn-house-price-predictor.web.app/',
    code: 'https://github.com/liamkande/knn-tensorflow-app',
    category: ['ai', 'ml', 'web'], // Multiple categories
    image: 'knn-logo',
    stats: { model: 'KNN', features: '4D space', predictions: 'Real-time' },
  },
  {
    id: 4,
    skills: ['Machine Learning', 'REACT 19', 'TYPESCRIPT', 'MATTER.JS', 'LUCIDE'],
    title: 'Plinko ML',
    description:
      'Machine learning application that predicts where Plinko balls will land based on drop position, bounciness, and size. Uses Advanced K-Nearest Neighbors Analysis Engine (KNN algorithm) to analyze ball trajectories and predict bucket outcomes with real-time accuracy metrics. Combines physics simulation with modern ML prediction.',
    preview: 'https://plinko-ml-react.web.app',
    code: 'https://github.com/liamkande/plinko-MachineLearning',
    category: ['ai', 'ml', 'web'], // Multiple categories
    image: 'plinko-logo',
    stats: { model: 'KNN', prediction: 'Real-time', accuracy: 'Adaptive' },
  },
  {
    id: 5,
    skills: ['React Native', 'TypeScript', 'Firebase', 'OpenAI', 'Recoil', 'Google Cloud'],
    title: 'SpiritSync Ai Mobile',
    description:
      'Cross-platform AI-powered mobile application providing wisdom and motivation inspired by the Bible. Features real-time Firebase integration, social authentication, and AI-crafted personalized content.',
    preview: 'https://spiritsync.app',
    code: 'https://github.com/spiritsyncai/spiritsync-ai-mobile',
    category: ['ai', 'mobile'], // Multiple categories
    image: 'spirit-logo',
    stats: { platforms: 'iOS+Android', auth: 'Multi', realtime: 'Firebase' },
  },
  {
    id: 6,
    skills: ['React', 'TypeScript', 'Styled Components', 'TV Navigation'],
    title: 'Disney+ TV Interface',
    description:
      'High-performance Disney+ TV Interface demonstrating TV development patterns. Implemented TV-style D-pad navigation with custom hooks, lazy-loading content rows using Intersection Observer, and optimized image loading with smart caching reducing API calls by 80%.',
    preview:
      'https://s3.us-east-2.amazonaws.com/liamkande.com/preview/disney-plus-roku/index.html',
    code: 'https://github.com/liamkande/disney-plus-roku',
    category: ['web'], // Changed to array
    image: 'disney-logo',
    stats: { cache: '80%↓', navigation: 'D-pad', loading: 'Lazy' },
  },
  {
    id: 7,
    skills: ['React 19', 'JavaScript', 'TypeScript', 'Google Cloud', 'Acuity'],
    title: 'Anna Ackerman Marketing Platform',
    description:
      'Designed and engineered responsive, performance-first React marketing site. Built device-aware sections with cropped image variants, lazy-loaded assets, and high-performance photo carousel with smooth transitions. Integrated Acuity scheduling with accessibility checks.',
    preview: 'https://annaackerman.com/',
    code: 'https://github.com/liamkande',
    category: ['web'], // Changed to array
    image: 'anna-logo',
    stats: { performance: '95+', loading: '<2s', optimization: 'A+' },
  },
  {
    id: 8,
    skills: ['Next.js', 'TypeScript', 'JavaScript', 'Vercel', 'SSR'],
    title: 'Simple Cloud Hosting',
    description:
      'Sleek and modern marketing page built with Next.js and TypeScript showcasing a cloud hosting provider. Features static content for performance with server-side rendering, dynamic navigation system, and optimized image handling. Deployed on Vercel for maximum scalability.',
    preview: 'https://my-corp-f99y59q72-liam-ansoumane-kandes-projects.vercel.app/',
    code: 'https://github.com/liamkande/my-corp-app',
    category: ['web'], // Changed to array
    image: 'cloud-logo',
    stats: { SSR: 'Next.js', deploy: 'Vercel', performance: 'Optimized' },
  },
]
